import { render, staticRenderFns } from "./SolanStudentViewHeader.vue?vue&type=template&id=5328e441&scoped=true&"
import script from "./SolanStudentViewHeader.vue?vue&type=script&lang=ts&"
export * from "./SolanStudentViewHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SolanStudentViewHeader.vue?vue&type=style&index=0&id=5328e441&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328e441",
  null
  
)

export default component.exports